import * as Constants from './Constants';

const initialState = {
  title: 'Order Confirmation',
  showHideROCart: false,
  notifyError: false,
  showConfirmationApiError: false,
  confirmationServiceInfo: null,
  confirmationError: false,
  confirmationNtfyMsg: null,
};

function orderConfirmation(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA_SUCCESS:
      return { ...state, title: action.response && action.response.data };
    case Constants.SHOW_ORDERCONFIRMATION_CART:
      return { ...state, showHideROCart: action.data && action.data };
    case Constants.GET_PROMO_SUCCESS: {
      return { ...state, promos: action.response.config };
    }
    case Constants.GET_CONFIRMSALE_SUCCESS:
      return { ...state, confirmsale: action.response && action.response };
    case Constants.ERR_OCCURED:
      return { ...state, notifyError: action.errorConfirm, confirmationServiceInfo: action.serviceinfo };
    case Constants.SHOW_CONFIRMATION_API_ERROR:
      return { ...state, showConfirmationApiError: action.errorConfirm, confirmationServiceInfo: action.serviceinfo };
    case Constants.CEF_ORDER_CONFIRMATION_ERROR:
      return { ...state, confirmationError: action.response, confirmationNtfyMsg: action.errorMessage };
    default:
      return state;
  }
}

export default orderConfirmation;
